import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { formatUnixDateTime } from '@/shared/lib/datetime';
import { getListRows, getTotalPages } from '@/shared/lib/pagination';
import { Pagination } from '@/shared/ui/Pagination';
import { QueryStatus } from '@/shared/ui/QueryStatus';
import { fetchBillingPaymentList } from './api';

interface PaymentRow extends Record<string, unknown> {
  id: number | string;
  status_id?: number;
  external_id?: string | number;
  user?: { phone?: string; email?: string; roles?: string[] | string } | null;
  amount?: number | string;
  currency?: { symbol?: string } | null;
  ip?: string;
  create_time?: number;
}

const PAYMENT_STATUS: Record<number, string> = {
  1: 'создан',
  2: 'завершен',
  3: 'отменен',
};

const formatRoles = (roles: string[] | string | undefined) => (Array.isArray(roles) ? roles.join(', ') : (roles ?? ''));

export const BillingPaymentPage = () => {
  const [page, setPage] = useState(1);

  const { data, isLoading, error } = useQuery({
    queryKey: ['billing-payment', page],
    queryFn: () => fetchBillingPaymentList(page),
  });

  const rows = getListRows<PaymentRow>(data, ['items']);

  return (
    <>
      <section className="content-header">
        <h1>Платежные запросы</h1>
      </section>
      <section className="content">
        <div className="box">
          <div className="box-header with-border">
            <h3 className="box-title">Список платежных запросов</h3>
          </div>
          <div className="box-body">
            <QueryStatus isLoading={isLoading} error={error} errorText="Ошибка загрузки платежных запросов" />
            <div style={{ overflowX: 'auto' }}>
              <table className="table table-bordered">
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Статус</th>
                    <th>ID в платежной системе</th>
                    <th>Телефон</th>
                    <th>Email</th>
                    <th>Сумма</th>
                    <th>Валюта</th>
                    <th>Роль</th>
                    <th>IP</th>
                    <th>Дата создания</th>
                  </tr>
                </thead>
                <tbody>
                  {rows.map((row) => (
                    <tr key={row.id}>
                      <td>{row.id}</td>
                      <td>{PAYMENT_STATUS[row.status_id ?? -1] ?? ''}</td>
                      <td>{row.external_id}</td>
                      <td>{row.user?.phone ?? ''}</td>
                      <td>{row.user?.email ?? ''}</td>
                      <td>{row.amount}</td>
                      <td>{row.currency?.symbol ?? ''}</td>
                      <td>{formatRoles(row.user?.roles)}</td>
                      <td>{row.ip}</td>
                      <td>{formatUnixDateTime(row.create_time)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <Pagination page={page} totalPages={getTotalPages(data)} onChange={setPage} />
          </div>
        </div>
      </section>
    </>
  );
};
